export default "__VITE_ASSET__CsBmy0bt__"